<template>
  <div class="main">
    <router-view class="content" />
    <van-tabbar route class="tab-bar">
      <van-tabbar-item to="/addcard" icon="search">查询</van-tabbar-item>
      <van-tabbar-item to="/card/index" icon="idcard">我的卡/设备</van-tabbar-item>
      <van-tabbar-item to="/mine" icon="user-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  import {
    Tabbar,
    TabbarItem
  } from 'vant';
  export default {
    name: 'Layout',
    components: {
      [Tabbar.name]: Tabbar,
      [TabbarItem.name]: TabbarItem,
    }
  }
</script>

<style scoped>
  .main {
    height: 100vh;
  }

  .content {
    height: 100vh;
    overflow-y: scroll;
  }

  .tab-bar {
    background-image: linear-gradient(to right, #C9FFBF 0%, #FFAFBD 51%, #C9FFBF 100%);
  }

  /deep/ .tab-bar .van-tabbar-item--active {
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/layout/index.vue